module.exports = __webpack_public_path__ + "static/media/viska.97c4409c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Landing/viska.mp4
// module id = 139
// module chunks = 0